'use client';

import React from 'react';
import { useLanguage } from '@/doi-tac-module/contexts/LanguageContext';
import { useNavigation } from '@/doi-tac-module/contexts/NavigationContext';

interface GlobalBrandedLoaderProps {
    forceShow?: boolean;
}

export const GlobalBrandedLoader = ({ forceShow = false }: GlobalBrandedLoaderProps) => {
    const { language } = useLanguage();
    const { navigatingPath } = useNavigation();

    if (!navigatingPath && !forceShow) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/30 backdrop-blur-md animate-in fade-in duration-500">
            <div className="relative flex flex-col items-center gap-10">
                {/* Spinner Area */}
                <div className="relative flex items-center justify-center h-24 w-24">
                    {/* Outer Spinner - Double Ring */}
                    <div className="absolute inset-0 rounded-full border-[3px] border-slate-100" />
                    <div className="absolute inset-0 rounded-full border-[3px] border-t-[#F2B92A] border-r-[#19A6DF] animate-spin shadow-[0_0_15px_rgba(25,166,223,0.1)]" />

                    {/* Inner Pulse Ring */}
                    <div className="absolute inset-2 rounded-full border border-primary/10 animate-pulse" />
                </div>

                {/* Text Area */}
                <div className="space-y-4 text-center px-6 max-w-sm">
                    <div className="flex flex-col gap-2">
                        <p className="text-xl font-bold text-[#19A6DF] animate-pulse tracking-tight">
                            {language === 'vi' ? 'Đang tải dữ liệu...' : 'ডেটা লোড হচ্ছে...'}
                        </p>
                        <p className="text-sm font-normal text-slate-500 tracking-wide">
                            {language === 'vi' ? 'Vui lòng đợi trong giây lát' : 'অনুগ্রহ করে কিছুক্ষণ chờ করুন'}
                        </p>
                    </div>

                    {/* Elegant Progress Line */}
                    <div className="w-56 h-1 bg-slate-100 rounded-full mx-auto overflow-hidden shadow-inner">
                        <div className="h-full bg-gradient-to-r from-[#19A6DF] via-[#F2B92A] to-[#19A6DF] animate-progress" />
                    </div>
                </div>
            </div>

            <style jsx>{`
                @keyframes progress {
                    0% {
                        transform: translateX(-100%);
                    }
                    100% {
                        transform: translateX(100%);
                    }
                }
                .animate-progress {
                    width: 100%;
                    animation: progress 2s infinite ease-in-out;
                }
            `}</style>
        </div>
    );
};
